import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSparkles } from '@fortawesome/pro-regular-svg-icons'
import {
  useLabraChatDispatch,
  useLabraChatSelector,
} from '../../modules/labraChat/context'
import { openLabraChat } from '../../modules/labraChat/actions'
import { selectIsLabraChatPanelOpen } from '../../modules/labraChat/selectors'
import { useStyles } from './LabraAIChatTriggerButton.styles'

export interface LabraAIChatTriggerButtonProps {
  /** Button text (defaults to "Ask Labra AI"). Product passes its agent name. */
  label?: string
}

export const LabraAIChatTriggerButton: React.FC<
  LabraAIChatTriggerButtonProps
> = ({ label = 'Ask Labra AI' }) => {
  const { classes } = useStyles()
  const dispatch = useLabraChatDispatch()
  const isPanelOpen = useLabraChatSelector(selectIsLabraChatPanelOpen)

  const handleClick = () => {
    dispatch(openLabraChat())
  }

  if (isPanelOpen) return null

  return (
    <div className={classes.wrapper}>
      <button
        className={classes.button}
        onClick={handleClick}
        type="button"
        data-testid="labra-ai-chat-trigger-button"
      >
        <FontAwesomeIcon icon={faSparkles} className={classes.icon} />
        <span className={classes.label}>{label}</span>
      </button>
    </div>
  )
}
